import type {
  FleetAutoBookingCreateApiData,
  FleetAutoBookingCreateApiResponses,
  FleetBookingCarSwapApiData,
  FleetBookingCarSwapApiResponses,
  FleetBookingCarSwapOptionsApiData,
  FleetBookingCarSwapOptionsApiResponses,
  FleetDepartmentListApiData,
  FleetDepartmentListApiResponses,
  FleetScheduleAvailabilityGetApiData,
  FleetScheduleAvailabilityGetApiResponses,
  FleetScheduleAvailabilitySetApiData,
  FleetScheduleAvailabilitySetApiResponses,
  FleetScheduleBatchPatchApiData,
  FleetScheduleBatchPatchApiResponses,
  FleetScheduleBookingCreateApiData,
  FleetScheduleBookingCreateApiResponses,
  FleetScheduleBookingCreateBatchApiData,
  FleetScheduleBookingCreateBatchApiResponses,
  FleetScheduleBookingCreateInput,
  FleetScheduleBookingSlotsListApiData,
  FleetScheduleBookingSlotsListApiResponses,
  FleetScheduleCreateApiData,
  FleetScheduleCreateApiResponses,
  FleetScheduleDeleteApiData,
  FleetScheduleDeleteApiResponses,
  FleetScheduleGetApiData,
  FleetScheduleGetApiResponses,
  FleetScheduleListApiData,
  FleetScheduleListApiResponses,
  FleetSchedulePatchApiData,
  FleetSchedulePatchApiResponses,
  FleetScheduleVehicleAddApiData,
  FleetScheduleVehicleAddApiResponses,
  FleetScheduleVehicleBookingsListApiData,
  FleetScheduleVehicleBookingsListApiResponses,
  FleetScheduleVehicleHoldCreateApiData,
  FleetScheduleVehicleHoldCreateApiResponses,
  FleetScheduleVehicleHoldDeleteApiData,
  FleetScheduleVehicleHoldDeleteApiResponses,
  FleetScheduleVehicleHoldListApiData,
  FleetScheduleVehicleHoldListApiResponses,
  FleetScheduleVehicleListAllApiData,
  FleetScheduleVehicleListAllApiResponses,
  FleetScheduleVehicleListApiData,
  FleetScheduleVehicleListApiResponses,
  FleetScheduleVehicleRemoveApiData,
  FleetScheduleVehicleRemoveApiResponses,
  FleetScheduleVehicleStatusPatchApiData,
  FleetScheduleVehicleStatusPatchApiResponses,
  FleetScheduleVehicleSwapApiData,
  FleetScheduleVehicleSwapApiResponses,
  FleetServiceAlertsListApiData,
  FleetServiceAlertsListApiResponses,
  FleetServiceCalendarGetApiData,
  FleetServiceCalendarGetApiResponses,
  FleetServiceCustomersListApiData,
  FleetServiceCustomersListApiResponses,
  FleetServiceOverviewGetApiData,
  FleetServiceOverviewGetApiResponses,
  FleetServicePlanningGetApiData,
  FleetServicePlanningGetApiResponses,
  UserGroupFleetScheduleVehicleSwapApiData,
  UserGroupFleetScheduleVehicleSwapApiResponses,
  UserGroupFleetScheduleVehicleSwapCandidateApiData,
  UserGroupFleetScheduleVehicleSwapCandidateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getFleetScheduleUrls = {
  getPaginatedFleetSchedules: dataEndpoint<FleetScheduleListApiData, FleetScheduleListApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-services/schedules/', queryParams)
  }),
  getFleetSchedule: dataEndpoint<FleetScheduleGetApiData, FleetScheduleGetApiResponses>({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/`)
  }),
  postFleetSchedule: responseEndpoint<FleetScheduleCreateApiData, FleetScheduleCreateApiResponses>({
    getUrl: () => apiUrl('fleet-services/schedules/'),
    getBody: (data) => data
  }),
  patchFleetSchedule: responseEndpoint<FleetSchedulePatchApiData, FleetSchedulePatchApiResponses>({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/`),
    getBody: (data) => data
  }),
  patchBatchFleetSchedules: responseEndpoint<FleetScheduleBatchPatchApiData, FleetScheduleBatchPatchApiResponses>({
    getUrl: () => apiUrl('fleet-services/schedules/batch/'),
    getBody: (data) => data
  }),
  deleteFleetSchedule: dataEndpoint<FleetScheduleDeleteApiData, FleetScheduleDeleteApiResponses>({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/`)
  }),
  getFleetScheduleAvailability: dataEndpoint<
    FleetScheduleAvailabilityGetApiData,
    FleetScheduleAvailabilityGetApiResponses
  >({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/availability/`)
  }),
  postFleetScheduleAvailability: responseEndpoint<
    FleetScheduleAvailabilitySetApiData,
    FleetScheduleAvailabilitySetApiResponses
  >({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/availability/`),
    getBody: (data) => data
  }),
  getPaginatedFleetScheduleVehicles: dataEndpoint<
    FleetScheduleVehicleListApiData,
    FleetScheduleVehicleListApiResponses
  >({
    getUrl: ({ fleetScheduleId, ...queryParams }) =>
      apiUrl(`fleet-services/schedules/${fleetScheduleId}/vehicles/`, queryParams)
  }),
  getPaginatedFleetScheduleVehiclesAll: dataEndpoint<
    FleetScheduleVehicleListAllApiData,
    FleetScheduleVehicleListAllApiResponses
  >({
    getUrl: (queryParams) => apiUrl('fleet-services/schedule-vehicles/', queryParams)
  }),
  postFleetScheduleVehicle: responseEndpoint<FleetScheduleVehicleAddApiData, FleetScheduleVehicleAddApiResponses>({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/vehicles/`),
    getBody: (data) => data
  }),
  patchFleetScheduleVehicleStatus: responseEndpoint<
    FleetScheduleVehicleStatusPatchApiData,
    FleetScheduleVehicleStatusPatchApiResponses
  >({
    getUrl: ({ fleetScheduleId, fleetScheduleVehicleId }) =>
      apiUrl(`fleet-services/schedules/${fleetScheduleId}/vehicles/${fleetScheduleVehicleId}/`),
    getBody: (data) => data
  }),
  postFleetScheduleVehicleRemove: responseEndpoint<
    FleetScheduleVehicleRemoveApiData,
    FleetScheduleVehicleRemoveApiResponses
  >({
    // The backend routes removal as POST .../vehicles/remove/ with a body of userGroupCarIds,
    // so this is a usePost even though it deletes enrollments.
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/vehicles/remove/`),
    getBody: ({ fleetScheduleId: _, ...body }) => body
  }),
  postFleetScheduleVehicleSwap: responseEndpoint<FleetScheduleVehicleSwapApiData, FleetScheduleVehicleSwapApiResponses>(
    {
      getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/vehicles/swap/`),
      getBody: ({ fleetScheduleId: _, ...body }) => body
    }
  ),
  // Worker app: swap a fleet booking's car with a car on a sibling schedule (same customer, same address).
  getFleetBookingCarSwapOptions: dataEndpoint<
    FleetBookingCarSwapOptionsApiData,
    FleetBookingCarSwapOptionsApiResponses
  >({
    getUrl: ({ bookingId }) => apiUrl(`fleet-services/bookings/${bookingId}/car-swap/`)
  }),
  postFleetBookingCarSwap: responseEndpoint<FleetBookingCarSwapApiData, FleetBookingCarSwapApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`fleet-services/bookings/${bookingId}/car-swap/`),
    getBody: ({ bookingId: _, ...body }) => body
  }),
  // Customer group admin swap: the incoming car must already be a car of the group.
  postUserGroupFleetScheduleVehicleSwap: responseEndpoint<
    UserGroupFleetScheduleVehicleSwapApiData,
    UserGroupFleetScheduleVehicleSwapApiResponses
  >({
    getUrl: ({ userGroupId, fleetScheduleVehicleId }) =>
      apiUrl(`fleet-services/user-groups/${userGroupId}/vehicles/${fleetScheduleVehicleId}/swap/`),
    getBody: ({ userGroupId: _, fleetScheduleVehicleId: __, ...body }) => body
  }),
  getUserGroupFleetScheduleVehicleSwapCandidate: dataEndpoint<
    UserGroupFleetScheduleVehicleSwapCandidateApiData,
    UserGroupFleetScheduleVehicleSwapCandidateApiResponses
  >({
    getUrl: ({ userGroupId, carId }) => apiUrl(`fleet-services/user-groups/${userGroupId}/swap-candidates/${carId}/`)
  }),
  getPaginatedFleetScheduleVehicleBookings: dataEndpoint<
    FleetScheduleVehicleBookingsListApiData,
    FleetScheduleVehicleBookingsListApiResponses
  >({
    getUrl: ({ fleetScheduleVehicleId, ...queryParams }) =>
      apiUrl(`fleet-services/vehicles/${fleetScheduleVehicleId}/bookings/`, queryParams)
  }),
  getPaginatedFleetScheduleVehicleHolds: dataEndpoint<
    FleetScheduleVehicleHoldListApiData,
    FleetScheduleVehicleHoldListApiResponses
  >({
    getUrl: ({ fleetScheduleVehicleId, ...queryParams }) =>
      apiUrl(`fleet-services/vehicles/${fleetScheduleVehicleId}/holds/`, queryParams)
  }),
  postFleetScheduleVehicleHold: responseEndpoint<
    FleetScheduleVehicleHoldCreateApiData,
    FleetScheduleVehicleHoldCreateApiResponses
  >({
    // Backend moved the hold-create path under the schedule; the target vehicle now
    // travels in the body.
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/vehicles/holds/`),
    getBody: ({ fleetScheduleId: _, ...body }) => body
  }),
  deleteFleetScheduleVehicleHold: dataEndpoint<
    FleetScheduleVehicleHoldDeleteApiData,
    FleetScheduleVehicleHoldDeleteApiResponses
  >({
    getUrl: ({ fleetScheduleVehicleId, holdId }) =>
      apiUrl(`fleet-services/vehicles/${fleetScheduleVehicleId}/holds/${holdId}/`)
  }),
  getFleetScheduleBookingSlots: dataEndpoint<
    FleetScheduleBookingSlotsListApiData,
    FleetScheduleBookingSlotsListApiResponses
  >({
    getUrl: ({ fleetScheduleId, ...queryParams }) =>
      apiUrl(`fleet-services/schedules/${fleetScheduleId}/booking-slots/`, queryParams)
  }),
  postFleetScheduleBookings: responseEndpoint<
    FleetScheduleBookingCreateApiData,
    FleetScheduleBookingCreateApiResponses
  >({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/bookings/`),
    getBody: ({ fleetScheduleId: _, ...body }) => body
  }),
  postFleetScheduleBookingsBatch: responseEndpoint<
    FleetScheduleBookingCreateBatchApiData,
    FleetScheduleBookingCreateBatchApiResponses
  >({
    getUrl: ({ fleetScheduleId }) => apiUrl(`fleet-services/schedules/${fleetScheduleId}/bookings/batch/`),
    // The API body is a bare JSON array. The caller hands us an array with a
    // tacked-on `fleetScheduleId` property (via Object.assign) so ApiInput's
    // path + body intersection is satisfiable. Spread back out to drop that
    // property AND preserve array-ness — destructuring would yield an object
    // with numeric keys and the server rejects it with "Expected list of objects".
    getBody: (input) => [...(input as Iterable<FleetScheduleBookingCreateInput>)] as unknown as Partial<typeof input>
  }),
  getFleetServiceOverview: dataEndpoint<FleetServiceOverviewGetApiData, FleetServiceOverviewGetApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-services/overview/', queryParams)
  }),
  getFleetServicePlanning: dataEndpoint<FleetServicePlanningGetApiData, FleetServicePlanningGetApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-services/planning/', queryParams)
  }),
  postFleetAutoBookings: responseEndpoint<FleetAutoBookingCreateApiData, FleetAutoBookingCreateApiResponses>({
    getUrl: () => apiUrl('fleet-services/auto-bookings/'),
    getBody: (body) => body
  }),
  getFleetServiceCalendar: dataEndpoint<FleetServiceCalendarGetApiData, FleetServiceCalendarGetApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-services/calendar/', queryParams)
  }),
  getPaginatedFleetServiceAlerts: dataEndpoint<FleetServiceAlertsListApiData, FleetServiceAlertsListApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-services/alerts/', queryParams)
  }),
  getPaginatedFleetServiceCustomers: dataEndpoint<
    FleetServiceCustomersListApiData,
    FleetServiceCustomersListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('fleet-services/customers/', queryParams)
  }),
  getPaginatedFleetDepartments: dataEndpoint<FleetDepartmentListApiData, FleetDepartmentListApiResponses>({
    getUrl: (queryParams) => apiUrl('fleet-services/departments/', queryParams)
  })
};
